module.exports = __webpack_public_path__ + "img/img-e50af754.d5088e04.png";